import { Box, HStack, Text, VStack } from "@chakra-ui/react";
import { RiVerifiedBadgeFill } from "react-icons/ri";
import { Link, useLocation, useNavigate } from "react-router";
import formatUsername from "../../helpers/formatUsername";
import { UserProvider } from "./provider";
import Name from "./_name";
import VerifiedBadge from "./_verifiedBadge";
import Image from "./_image";

/**
 * Regular User view
 * @param {import("./props").UserProps} props
 */
export default function RegularUser(props) {
  return (
    <UserProvider user={props}>
      <HStack spacing="3" minW={0} w="max-content">
        <Image h="35px" w="35px" />
        <VStack spacing="0" align="flex-start" minW={0}>
          <Name variant="fullName">
            <VerifiedBadge />
          </Name>
          <Name>{props.extra}</Name>
        </VStack>
      </HStack>
    </UserProvider>
  );
}
